export const ENDPOINTS_STUDENT = {
  CHECK_BOOK_LICENSE:
    '/bff-vle/students/:studentId/classes/:classCode/license/:licenseCode/checkJoin',
  CHECK_CLASS_CODE: '/bff-vle/students/:studentId/classes/:classCode/checkJoin',
  COURSES: '/bff-vle/schools/:schoolId/courses',
  JOIN_CLASS:
    '/bff-vle/students/:studentId/classes/:classCode/license/:licenseCode',
  ME_CHILDREN: '/bff-vle/me/children',
  ME_CHILDREN_CHILD_ID: '/bff-vle/me/children/:childId',
  REMOVE_STUDENT_FROM_CLASS: '/bff-vle/classes/:classId/students/:userId',
  SAVE_STUDENT_CLASSROOM:
    '/bff-vle/classrooms/:classroomId/students/:studentId',
  STUDENTS_VALIDATION_REQUESTS:
    '/bff-vle/classes/:classroomId/getStudentsAndValidationRequests',
  STUDENT_CHILDREN_LOGIN: '/bff-vle/student/children/:childrenId/login',
  STUDENT_CLASSROOMS: '/bff-vle/students/:studentId/classrooms',
  STUDENT_CLASSROOMS_BY_COURSE:
    '/bff-vle/schools/:schoolId/classrooms?courseId=:courseId',
  STUDENT_COURSES: '/bff-vle/students/:studentId/courses',
  STUDENT_IN_CLASS: '/bff-vle/classes/:classId/students',
}
